import gql from 'graphql-tag.macro'

export const getNotifications = gql`
  query ($since: Int, $limit: Int, $offset: Int) {
    notifications(
      types: ["mention_created", "comment_created:comment"]
      since: $since
      limit: $limit
      offset: $offset
    ) {
      ... on NotificationMentionCreated {
        entityBundle
        entityId
        stateRead
        author: entityOwner {
          entityType
          name
          mail
          fieldFirstName
          fieldLastName
        }
        entityCreated
        sixtMention {
          entity {
            mentionOnEntityId {
              entity {
                entityIdOfComment {
                  entity {
                    entityId
                  }
                }
                fieldName
              }
            }
          }
        }
      }
      ... on NotificationCommentCreatedComment {
        entityBundle
        entityId
        stateRead
        author: entityOwner {
          entityType
          name
          mail
          fieldFirstName
          fieldLastName
        }
        entityCreated
        comment {
          entity {
            entityIdOfComment {
              entity {
                entityId
                __typename
              }
            }
            entityId
            cid
            subject
            thread
            fieldName
          }
        }
      }
    }
  }
`
export const getNotificationsCount = gql`
  query {
    notificationsCount(types: ["mention_created", "comment_created:comment"])
  }
`
export const readAllNotificationsMutation = gql`
  mutation {
    notiticationsMarkAllAsRead
  }
`
export const readNotificationMutation = gql`
  mutation ($entity_id: String!) {
    notiticationsMarkAsRead(entity_id: $entity_id)
  }
`

export const updateNotificationCountRedis = gql`
  mutation ($data: Int) {
    updateNotificationCount(key: "notification-count", data: $data) {
      status
      errorMessage
    }
  }
`
export const getNotificationCountRedis = gql`
  query {
    getNotificationCount(key: "notification-count") {
      notificationCount
    }
  }
`
